import { useParams } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import primeClient from "../../../../axios/primeClient";
import { createContext, useContext, useState, useEffect, useRef } from "react";
import { Card } from "../../../../Components/Card";
import * as echarts from "echarts";
import { useTranslation } from "react-i18next";
import Recommendations from "../../../../Components/Recommendations";
import { Colors } from "../../../../constants/Colors";

const DataContext = createContext();

export const DetailTraffic = () => {
  const { interfaceId } = useParams();

  const { t, i18n } = useTranslation();

  const { data, isLoading, error } = useFetch({
    url: `/v1/apps/traffic/detail?interface_id=${interfaceId}&duration=day`,
    client: primeClient,
  });

  const {
    data: dataWeek,
    isLoading: isLoadingWeek,
    error: errorWeek,
  } = useFetch({
    url: `/v1/apps/traffic/detail?interface_id=${interfaceId}&duration=week`,
    client: primeClient,
  });

  const [isToday, setIsToday] = useState(true);
  const [isAnomalyInClicked, setIsAnomalyInClicked] = useState(false);
  const [isAnomalyOutClicked, setIsAnomalyOutClicked] = useState(false);
  const [inChart, setInChart] = useState(true);

  const toggleToday = () => {
    setIsToday((prev) => !prev);
  };

  const toggleChart = () => {
    setInChart((prev) => !prev);
  };

  const clickAnomaly = ({ type }) => {
    if (type === "in") {
      setIsAnomalyInClicked(true);
    } else {
      setIsAnomalyOutClicked(true);
    }
  };

  const closeAnomaly = ({ type }) => {
    if (type === "in") {
      setIsAnomalyInClicked(false);
    } else {
      setIsAnomalyOutClicked(false);
    }
  };

  useEffect(() => {
    closeAnomaly({ type: "in" });
    closeAnomaly({ type: "out" });
  }, []);
  return (
    <DataContext.Provider
      value={{
        data,
        isLoading,
        error,
        dataWeek,
        isLoadingWeek,
        errorWeek,
        isToday,
        t,
        i18n,
      }}
    >
      <>
        <div
          style={{
            padding: "1rem",
            paddingTop: "2rem",
            width: "100%",
            height: "100%",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              fontSize: "1.25rem",
              marginBottom: "0.5rem",
              fontWeight: "bold",
            }}
          >
            {i18n.language === "id"
              ? "Analisis Detail Trafik"
              : "Detail Traffic Analysis"}
          </div>
          <DeviceDescriptionCard />
          <Card style={{ padding: "1rem", marginTop: "1rem" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  textAlign: "center",
                }}
              >
                {t(
                  "prime.detailAnalysis.trafficUtilization.performanceAnalysis"
                )}
              </p>
              <SwitchButton inChart={inChart} toggleChart={toggleChart} />
              <Picker isToday={isToday} toggleToday={toggleToday} />
            </div>
            {isToday ? (
              isLoading || error ? (
                <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
                  Loading...
                </p>
              ) : (
                <PerformanceChart
                  data={
                    inChart
                      ? data.usage.in.map((d) => d.value)
                      : data.usage.out.map((d) => d.value)
                  }
                  labels={
                    inChart
                      ? data.usage.in.map((d) => d.time.slice(11, 16))
                      : data.usage.out.map((d) => d.time.slice(11, 16))
                  }
                />
              )
            ) : isLoadingWeek || errorWeek ? (
              <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
                Loading...
              </p>
            ) : (
              <PerformanceChart
                data={
                  inChart
                    ? dataWeek.usage.in.map((d) => d.value)
                    : dataWeek.usage.out.map((d) => d.value)
                }
                labels={
                  inChart
                    ? dataWeek.usage.in.map((d) => d.time.slice(0, 16))
                    : dataWeek.usage.out.map((d) => d.time.slice(0, 16))
                }
              />
            )}
            <TrendTableCard clickAnomaly={clickAnomaly} />
            <br /> <hr /> <br />
            <SummaryAnalysisCard />
            <br /> <hr /> <br />
            <ConclusionCard />
            <br /> <hr /> <br />
            <RecommendationCard />
          </Card>
          {/* { isLoading || error ? null :
          <Recommendations 
          rootCause={[{ traffic: [data.ip] },]}
          deviceName={data.node_inventory_name}
          />
          } */}
        </div>
        {isAnomalyInClicked && (
          <FloatingAnomalies
            closeAnomaly={() => closeAnomaly({ type: "in" })}
            type="in"
          />
        )}
        {isAnomalyOutClicked && (
          <FloatingAnomalies
            closeAnomaly={() => closeAnomaly({ type: "out" })}
            type="out"
          />
        )}
      </>
    </DataContext.Provider>
  );
};

const DeviceDescriptionCard = () => {
  const { data, isLoading, error } = useContext(DataContext);

  return (
    <Card
      style={{
        width: "100%",
        maxWidth: "600px",
        backgroundColor: Colors.primary100,
        color: Colors.white,
        padding: "0.5rem 1rem",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "bold",
        }}
      >
        <div>
          {isLoading || error ? "Device Name" : data.node_inventory_name}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>Traffic | {isLoading || error ? "IP Address" : data.ip}</div>
      </div>
    </Card>
  );
};

const Picker = ({ isToday, toggleToday }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "1rem",
        borderRadius: "0.5rem",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        borderBlock: "1px solid rgba(0,0,0,0.1)",
      }}
    >
      <button
        style={{
          padding: "0.5rem 0.5rem",
          backgroundColor: isToday ? Colors.primary100 : Colors.white,
          color: isToday ? Colors.white : Colors.primary100,
          border: "none",
          cursor: "pointer",
          borderTopLeftRadius: "0.5rem",
          borderBottomLeftRadius: "0.5rem",
          fontWeight: isToday ? "bold" : "normal",
          fontSize: "0.8rem",
        }}
        onClick={toggleToday}
      >
        {t("prime.detailAnalysis.trafficUtilization.today")}
      </button>
      <button
        style={{
          padding: "0.5rem 0.5rem",
          backgroundColor: !isToday ? Colors.primary100 : Colors.white,
          color: !isToday ? Colors.white : Colors.primary100,
          border: "none",
          cursor: "pointer",
          borderTopRightRadius: "0.5rem",
          borderBottomRightRadius: "0.5rem",
          fontWeight: !isToday ? "bold" : "normal",
          fontSize: "0.8rem",
        }}
        onClick={toggleToday}
      >
        {t("prime.detailAnalysis.trafficUtilization.thisWeek")}
      </button>
    </div>
  );
};

// make a button component that can change the performance chart from in to out

const SwitchButton = ({ inChart, toggleChart }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "1rem",
        borderRadius: "0.5rem",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        borderBlock: "1px solid rgba(0,0,0,0.1)",
      }}
    >
      <button
        style={{
          padding: "0.5rem 0.5rem",
          backgroundColor: inChart ? Colors.primary100 : Colors.white,
          color: inChart ? Colors.white : Colors.primary100,
          border: "none",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "0.8rem",
          borderRadius: "0.5rem",
          width: "5rem",
        }}
        onClick={toggleChart}
      >
        {" "}
        {inChart ? "IN" : "OUT"}
      </button>
    </div>
  );
};

const PerformanceChart = ({ data, labels }) => {
  const chartRef = useRef(null); // Create a ref for the chart container

  useEffect(() => {
    if (chartRef.current) {
      // Initialize the chart
      const myChart = echarts.init(chartRef.current);

      // Set the chart options
      myChart.setOption({
        xAxis: {
          type: "category",
          data: labels,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: data,
            type: "line",
          },
        ],
      });

      // Cleanup on component unmount
      return () => {
        myChart.dispose();
      };
    }
  }, [data, labels]); // Re-initialize the chart when data or labels change

  return (
    <div
      ref={chartRef} // Assign the ref to the container
      style={{ width: "100%", height: 300 }}
    ></div>
  );
};

const TrendTableCard = ({ clickAnomaly, type }) => {
  const {
    data,
    isLoading,
    error,
    dataWeek,
    isLoadingWeek,
    errorWeek,
    isToday,
    t,
    i18n,
  } = useContext(DataContext);

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: Colors.neutral10,
                padding: "0.5rem 1rem",
                marginBottom: "5px",
                fontSize: "0.8rem",
                fontWeight: 700,
                borderBottomLeftRadius: "5px",
                borderTopLeftRadius: "5px",
              }}
            >
              Traffic
            </th>

            <th
              style={{
                backgroundColor: Colors.neutral10,
                padding: "0.5rem 1rem",
                marginBottom: "5px",
                fontSize: "0.8rem",
                fontWeight: 700,
              }}
            >
              {t("prime.detailAnalysis.trafficUtilization.trendPattern")}
            </th>
            <th
              style={{
                backgroundColor: Colors.neutral10,
                padding: "0.5rem 1rem",
                marginBottom: "5px",
                fontSize: "0.8rem",
                fontWeight: 700,
              }}
            >
              {t("prime.detailAnalysis.trafficUtilization.trendSlope")}
            </th>
            <th
              style={{
                backgroundColor: Colors.neutral10,
                padding: "0.5rem 1rem",
                marginBottom: "5px",
                fontSize: "0.8rem",
                fontWeight: 700,
                borderBottomRightRadius: "5px",
                borderTopRightRadius: "5px",
              }}
            >
              {t("prime.detailAnalysis.trafficUtilization.anomaly")}
            </th>
          </tr>
        </thead>
        <tbody>
          {isToday ? (
            isLoading ? (
              <tr style={{ fontSize: "0.8rem" }}>
                <td colSpan="4">Loading...</td>
              </tr>
            ) : error ? (
              <tr style={{ fontSize: "0.8rem" }}>
                <td colSpan="4">Error: {error.message}</td>
              </tr>
            ) : (
              <>
                <tr style={{ fontSize: "0.8rem" }}>
                  <td style={{ textAlign: "center" }}>IN</td>
                  <td style={{ textAlign: "center" }}>
                    {data.trend.in.pattern}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {data.trend.in.trend_slope}%
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {data.is_anomaly.in === "no" ? (
                      "No"
                    ) : (
                      <div
                        style={{
                          color: "blue",
                          underline: "true",
                          cursor: "pointer",
                        }}
                        onClick={() => clickAnomaly({ type: "in" })}
                      >
                        {" "}
                        {t("prime.detailAnalysis.trafficUtilization.view")}
                      </div>
                    )}
                  </td>
                </tr>

                <tr style={{ fontSize: "0.8rem" }}>
                  <td style={{ textAlign: "center" }}>OUT</td>
                  <td style={{ textAlign: "center" }}>
                    {data.trend.out.pattern}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {data.trend.out.trend_slope}%
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {data.is_anomaly.out === "no" ? (
                      "No"
                    ) : (
                      <div
                        style={{
                          color: "blue",
                          underline: "true",
                          cursor: "pointer",
                        }}
                        onClick={() => clickAnomaly({ type: "out" })}
                      >
                        {t("prime.detailAnalysis.trafficUtilization.view")}
                      </div>
                    )}
                  </td>
                </tr>
              </>
            )
          ) : isLoadingWeek ? (
            <tr style={{ fontSize: "0.8rem" }}>
              <td colSpan="4">Loading...</td>
            </tr>
          ) : errorWeek ? (
            <tr style={{ fontSize: "0.8rem" }}>
              <td colSpan="4">Error: {errorWeek.message}</td>
            </tr>
          ) : (
            <>
              <tr style={{ fontSize: "0.8rem" }}>
                <td style={{ textAlign: "center" }}>IN</td>
                <td style={{ textAlign: "center" }}>
                  {dataWeek.trend.in.pattern}
                </td>
                <td style={{ textAlign: "center" }}>
                  {dataWeek.trend.in.trend_slope}%
                </td>
                <td style={{ textAlign: "center" }}>
                  {dataWeek.is_anomaly.in === "no" ? (
                    "No"
                  ) : (
                    <div
                      style={{
                        color: "blue",
                        underline: "true",
                        cursor: "pointer",
                      }}
                      onClick={() => clickAnomaly({ type: "in" })}
                    >
                      {t("prime.detailAnalysis.trafficUtilization.view")}
                    </div>
                  )}
                </td>
              </tr>
              <tr style={{ fontSize: "0.8rem" }}>
                <td style={{ textAlign: "center" }}>OUT</td>
                <td style={{ textAlign: "center" }}>
                  {dataWeek.trend.out.pattern}
                </td>
                <td style={{ textAlign: "center" }}>
                  {dataWeek.trend.out.trend_slope}%
                </td>
                <td style={{ textAlign: "center" }}>
                  {dataWeek.is_anomaly.out === "no" ? (
                    "No"
                  ) : (
                    <div
                      style={{
                        color: "blue",
                        underline: "true",
                        cursor: "pointer",
                      }}
                      onClick={clickAnomaly}
                    >
                      View
                    </div>
                  )}
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

const SummaryAnalysisCard = () => {
  const {
    data,
    isLoading,
    error,
    dataWeek,
    isLoadingWeek,
    errorWeek,
    isToday,
    t,
    i18n,
  } = useContext(DataContext);
  return (
    <div style={{}}>
      <p
        style={{
          fontWeight: "bold",
          fontSize: "1.1rem",
          color: "black",
          marginBottom: "10px",
        }}
      >
        {t("prime.detailAnalysis.trafficUtilization.summaryAnalysis.header")}
      </p>

      <p
        style={{
          backgroundColor: Colors.neutral10,
          padding: "0.5rem 1rem",
          marginBottom: "2px",
          fontSize: "0.9rem",
          fontWeight: 700,
          borderRadius: "5px",
        }}
      >
        Traffic IN
      </p>
      <p
        style={{
          fontSize: "0.8rem",
          textAlign: "justify",
          padding: "0.1rem 1rem",
          marginBottom: "1rem",
        }}
      >
        {isToday ? (
          isLoading ? (
            "Loading..."
          ) : error ? (
            `Error: ${error.message}`
          ) : i18n.language === "id" ? (
            <p>
              <strong>Kapasitas Traffic</strong> Anda hari ini dalam kondisi{" "}
              {data.usage_category.in}. Rata-rata Usage Traffic pada Interface{" "}
              {data.node_inventory_name} <strong>hari ini</strong> adalah{" "}
              {data.average.in} mbps, usage Trafik memiliki trend{" "}
              <strong>kenaikan</strong> sebesar{" "}
              <strong>{data.trend.in.trend_slope}% per hari</strong> dengan pola
              trend yaitu <strong>{data.trend.in.pattern}</strong>,
              {data.is_anomaly.in === "no"
                ? " tidak ditemukan anomali pada data hari ini"
                : " terdapat anomali pada data hari ini"}
              .
            </p>
          ) : (
            <p>
              Your <strong>traffic capacity</strong> today is in{" "}
              {data.usage_category.in} condition. The average usage traffic on
              Interface {data.node_inventory_name} <strong>today</strong> is{" "}
              {data.average.in} mbps, the traffic usage has a
              <strong> increase</strong> trend of{" "}
              <strong>{data.trend.in.trend_slope}% per day</strong> with a trend
              pattern of <strong>{data.trend.in.pattern}</strong>,
              {data.is_anomaly.in === "no"
                ? " no anomaly found in today's data"
                : " there is an anomaly in today's data"}
              .
            </p>
          )
        ) : isLoadingWeek ? (
          "Loading..."
        ) : errorWeek ? (
          `Error: ${errorWeek.message}`
        ) : i18n.language === "id" ? (
          <p>
            <strong>Kapasitas Traffic</strong> Anda dalam seminggu terakhir
            dalam kondisi {dataWeek.usage_category.in}. Rata-rata Usage Traffic
            pada Interface {dataWeek.node_inventory_name}{" "}
            <strong>minggu ini</strong> adalah {dataWeek.average.in} mbps, usage
            Trafik memiliki trend <strong>kenaikan</strong> sebesar{" "}
            <strong>{dataWeek.trend.in.trend_slope}% per hari</strong> dengan
            pola trend yaitu <strong>{dataWeek.trend.in.pattern}</strong>,
            {dataWeek.is_anomaly.in === "no"
              ? " tidak ditemukan anomali pada data minggu ini"
              : " terdapat anomali pada data minggu ini"}
            .
          </p>
        ) : (
          <p>
            Your <strong>traffic capacity</strong> in this week is in{" "}
            {dataWeek.usage_category.in} condition. The average usage traffic on
            Interface {dataWeek.node_inventory_name} <strong>this week</strong>{" "}
            is {dataWeek.average.in} mbps, the traffic usage has a
            <strong> increase</strong> trend of{" "}
            <strong>{dataWeek.trend.in.trend_slope}% per day</strong> with a
            trend pattern of <strong>{dataWeek.trend.in.pattern}</strong>,
            {dataWeek.is_anomaly.in === "no"
              ? " no anomaly found in this week's data"
              : " there is an anomaly in this week's data"}
            .
          </p>
        )}
      </p>

      {/* title: traffic OUT */}
      <p
        style={{
          backgroundColor: Colors.neutral10,
          padding: "0.5rem 1rem",
          marginBottom: "2px",
          fontSize: "0.9rem",
          fontWeight: 700,
          borderRadius: "5px",
        }}
      >
        Traffic OUT
      </p>
      <p
        style={{
          fontSize: "0.8rem",
          textAlign: "justify",
          padding: "0.1rem 1rem",
        }}
      >
        {isToday ? (
          isLoading ? (
            "Loading..."
          ) : error ? (
            `Error: ${error.message}`
          ) : i18n.language === "id" ? (
            <p>
              <strong>Kapasitas Traffic</strong> Anda hari ini dalam kondisi{" "}
              {data.usage_category.out}. Rata-rata Usage Traffic pada Interface{" "}
              {data.node_inventory_name} <strong>hari ini</strong> adalah{" "}
              {data.average.out} mbps, usage Trafik memiliki trend{" "}
              <strong>kenaikan</strong> sebesar{" "}
              <strong>{data.trend.out.trend_slope}% per hari</strong> dengan
              pola trend yaitu <strong>{data.trend.out.pattern}</strong>,
              {data.is_anomaly.out === "no"
                ? " tidak ditemukan anomali pada data hari ini"
                : " terdapat anomali pada data hari ini"}
              .
            </p>
          ) : (
            <p>
              Your <strong>traffic capacity</strong> today is in{" "}
              {data.usage_category.out} condition. The average usage traffic on
              Interface {data.node_inventory_name} <strong>today</strong> is{" "}
              {data.average.out} mbps, usage Trafik has a{" "}
              <strong>increase</strong> trend of{" "}
              <strong>{data.trend.out.trend_slope}% per day</strong> with a
              trend pattern of <strong>{data.trend.out.pattern}</strong>,
              {data.is_anomaly.out === "no"
                ? " no anomaly found in today's data"
                : " there is an anomaly in today's data"}
              .
            </p>
          )
        ) : isLoadingWeek ? (
          "Loading..."
        ) : errorWeek ? (
          `Error: ${errorWeek.message}`
        ) : i18n.language === "id" ? (
          <p>
            <strong>Kapasitas Traffic</strong> Anda dalam seminggu terakhir
            dalam kondisi {dataWeek.usage_category.out}. Rata-rata Usage Traffic
            pada Interface {dataWeek.node_inventory_name}{" "}
            <strong>minggu ini</strong> adalah {dataWeek.average.out} mbps,
            usage Trafik memiliki trend <strong>kenaikan</strong> sebesar{" "}
            <strong>{dataWeek.trend.out.trend_slope}% per hari</strong> dengan
            pola trend yaitu <strong>{dataWeek.trend.out.pattern}</strong>,
            {dataWeek.is_anomaly.out === "no"
              ? " tidak ditemukan anomali pada data minggu ini"
              : " terdapat anomali pada data minggu ini"}
            .
          </p>
        ) : (
          <p>
            Your <strong>traffic capacity</strong> in this week is in{" "}
            {dataWeek.usage_category.out} condition. The average usage traffic
            on Interface {dataWeek.node_inventory_name}{" "}
            <strong>this week</strong> is {dataWeek.average.out} mbps, usage
            Trafik has a <strong>increase</strong> trend of{" "}
            <strong>{dataWeek.trend.out.trend_slope}% per day</strong> with a
            trend pattern of <strong>{dataWeek.trend.out.pattern}</strong>,
            {dataWeek.is_anomaly.out === "no"
              ? " no anomaly found in this week's data"
              : " there is an anomaly in this week's data"}
            .
          </p>
        )}
      </p>
    </div>
  );
};

const ConclusionCard = () => {
  const {
    data,
    isLoading,
    error,
    dataWeek,
    isLoadingWeek,
    errorWeek,
    isToday,
    i18n,
    t,
  } = useContext(DataContext);
  return (
    <div style={{}}>
      <p
        style={{
          fontWeight: "bold",
          fontSize: "1.1rem",
          color: "black",
          marginBottom: "10px",
        }}
      >
        {t("prime.detailAnalysis.trafficUtilization.conclusion")}
      </p>
      <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
        {isToday ? (
          isLoading ? (
            "Loading..."
          ) : error ? (
            `Error: ${error.message}`
          ) : i18n.language === "id" ? (
            <p>
              {data.average.in > data.average.out ? "Trafik IN" : "Trafik OUT"}{" "}
              Anda cenderung <strong>lebih besar</strong> dibandungkan dengan{" "}
              {data.average.in > data.average.out ? "Trafik OUT" : "Trafik IN"}.
              Sehingga dapat disimpulkan penggunaan internet Anda{" "}
              <strong>
                didominasi dengan aktvitas{" "}
                {data.average.in > data.average.out ? "upload" : "download"}
              </strong>
              .
            </p>
          ) : (
            <p>
              {data.average.in > data.average.out
                ? "Your Traffic IN"
                : "Your Traffic OUT"}{" "}
              is <strong>larger</strong> compared to{" "}
              {data.average.in > data.average.out
                ? "Traffic OUT"
                : "Traffic IN"}
              . Thus, it can be concluded that your internet usage is{" "}
              <strong>
                dominated by{" "}
                {data.average.in > data.average.out ? "upload" : "download"}{" "}
                activities
              </strong>
              .
            </p>
          )
        ) : isLoadingWeek ? (
          "Loading..."
        ) : errorWeek ? (
          `Error: ${errorWeek.message}`
        ) : i18n.language === "id" ? (
          <p>
            {dataWeek.average.in > dataWeek.average.out
              ? "Trafik IN"
              : "Trafik OUT"}{" "}
            Anda cenderung <strong>lebih besar</strong> dibandungkan dengan{" "}
            {dataWeek.average.in > dataWeek.average.out
              ? "Trafik OUT"
              : "Trafik IN"}
            . Sehingga dapat disimpulkan penggunaan internet Anda{" "}
            <strong>
              didominasi dengan aktvitas{" "}
              {dataWeek.average.in > dataWeek.average.out
                ? "upload"
                : "download"}
            </strong>
            .
          </p>
        ) : (
          <p>
            {dataWeek.average.in > dataWeek.average.out
              ? "Your Traffic IN"
              : "Your Traffic OUT"}{" "}
            is <strong>larger</strong> compared to{" "}
            {dataWeek.average.in > dataWeek.average.out
              ? "Traffic OUT"
              : "Traffic IN"}
            . Thus, it can be concluded that your internet usage is{" "}
            <strong>
              dominated by{" "}
              {dataWeek.average.in > dataWeek.average.out
                ? "upload"
                : "download"}{" "}
              activities
            </strong>
            .
          </p>
        )}
      </p>
    </div>
  );
};

const RecommendationCard = () => {
  const { t } = useContext(DataContext);
  return (
    <div style={{}}>
      <p
        style={{
          fontWeight: "bold",
          fontSize: "1.1rem",
          color: "black",
          marginBottom: "10px",
        }}
      >
        {t("prime.detailAnalysis.trafficUtilization.solution")}
      </p>
      <p style={{ fontSize: "0.8rem", textAlign: "justify" }}>
        {t("prime.detailAnalysis.trafficUtilization.solutionText")}
      </p>
    </div>
  );
};

const FloatingAnomalies = ({ closeAnomaly, type }) => {
  const {
    data,
    isLoading,
    error,
    dataWeek,
    isLoadingWeek,
    errorWeek,
    isToday,
  } = useContext(DataContext);

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 999,
          pointerEvents: "auto",
        }}
        onClick={closeAnomaly}
      ></div>

      {/* Modal */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          backgroundColor: "white",
          boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
          borderRadius: "10px",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
          cursor: "pointer",
          width: window.innerWidth > 600 ? "400px" : "80%",
        }}
      >
        <Card
          style={{
            padding: "1rem",
            maxHeight: window.innerHeight - 30,
            overflowY: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "1.1rem",
                color: "black",
              }}
            >
              Anomalies - Traffic {type === "in" ? "IN" : "OUT"}
            </div>
            <button
              onClick={closeAnomaly}
              style={{
                border: "none",
                backgroundColor: "white",
                cursor: "pointer",
                fontWeight: 700,
              }}
            >
              X
            </button>
          </div>
          <table style={{ width: "100%" }}>
            <thead>
              <tr
                style={{
                  backgroundColor: Colors.neutral10,
                  borderRadius: "5px",
                }}
              >
                <th style={{ fontSize: "0.8rem", fontWeight: 700 }}>Time</th>
                <th style={{ fontSize: "0.8rem", fontWeight: 700 }}>Usage</th>
                <th style={{ fontSize: "0.8rem", fontWeight: 700 }}>
                  Deviation
                </th>
              </tr>
            </thead>
            <tbody>
              {isToday ? (
                isLoading ? (
                  <tr>
                    <td colSpan="3" style={{ fontSize: "0.8rem" }}>
                      Loading...
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan="3" style={{ fontSize: "0.8rem" }}>
                      Error: {error.message}
                    </td>
                  </tr>
                ) : (
                  data.anomalies[type].map((anomaly) => (
                    <tr key={anomaly.time}>
                      <td style={{ fontSize: "0.8rem" }}>
                        {anomaly.time.slice(0, 16)}
                      </td>
                      <td style={{ fontSize: "0.8rem" }}>
                        {type === "in"
                          ? anomaly.link_in.toFixed(3)
                          : anomaly.link_out.toFixed(3)}
                      </td>
                      <td style={{ fontSize: "0.8rem" }}>
                        {anomaly.deviation.toFixed(2)}
                      </td>
                    </tr>
                  ))
                )
              ) : isLoadingWeek ? (
                <tr>
                  <td colSpan="3" style={{ fontSize: "0.8rem" }}>
                    Loading...
                  </td>
                </tr>
              ) : errorWeek ? (
                <tr>
                  <td colSpan="3" style={{ fontSize: "0.8rem" }}>
                    Error: {errorWeek.message}
                  </td>
                </tr>
              ) : (
                dataWeek.anomalies[type].map((anomaly) => (
                  <tr key={anomaly.time}>
                    <td style={{ fontSize: "0.8rem" }}>
                      {anomaly.time.slice(0, 16)}
                    </td>
                    <td style={{ fontSize: "0.8rem" }}>
                      {type === "in"
                        ? anomaly.link_in.toFixed(3)
                        : anomaly.link_out.toFixed(3)}
                    </td>
                    <td style={{ fontSize: "0.8rem" }}>
                      {anomaly.deviation.toFixed(2)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </Card>
      </div>
    </>
  );
};
